import { audienceBuilderStore } from "src/modules/engagement/components/phases/audience/audienceBuilderStore.ts";
import { CommandGetEntities } from "./commands/cmdGetEntities.ts";
import { CommandPreviewAudience } from "./commands/cmdPreviewAudience";

export class AudienceBuilderService {
  // `audienceId` follows audience -> launch -> population -> ingest definition -> field
  // map, so the picker offers the fields THIS population loads rather than every field
  // the org's definitions union (and never the whole vertical catalog).
  async loadEntities(organizationId: number, audienceId: number | null = null) {
    // Return cached if same org + audience
    if (
      audienceBuilderStore.organizationId === organizationId &&
      audienceBuilderStore.audienceId === audienceId &&
      audienceBuilderStore.entities.length > 0
    ) {
      return;
    }

    audienceBuilderStore.isLoadingEntities = true;
    audienceBuilderStore.organizationId = organizationId;
    audienceBuilderStore.audienceId = audienceId;
    audienceBuilderStore.entities = [];

    try {
      const entities = await new CommandGetEntities().run(organizationId, audienceId);
      audienceBuilderStore.entities = entities;
    } catch (error) {
      console.error("Failed to load entities:", error);
      audienceBuilderStore.organizationId = null;
      throw error;
    } finally {
      audienceBuilderStore.isLoadingEntities = false;
    }
  }

  async previewAudience(audienceId: number, rules: any) {
    audienceBuilderStore.isLoadingPreview = true;
    audienceBuilderStore.previewCount = null;

    try {
      const result = await new CommandPreviewAudience().run(audienceId, { rules });
      audienceBuilderStore.previewCount = result.preview_count;
      return result;
    } catch (error) {
      console.error("Failed to preview audience:", error);
      throw error;
    } finally {
      audienceBuilderStore.isLoadingPreview = false;
    }
  }

  clearEntities() {
    audienceBuilderStore.organizationId = null;
    audienceBuilderStore.entities = [];
    audienceBuilderStore.previewCount = null;
  }
}